import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import ControlsGroup from '#components/m/ControlsGroup'
import Button from '#components/a/Button'

class NotificationModal extends React.Component {
  render() {
    return (
      <div className="modal__wrap">
        <ReactModal
          isOpen={this.props.showModal}
          shouldCloseOnOverlayClick
          className={`modal modal--${this.props.modifier}`}
          overlayClassName={`modal__overlay${
            this.props.overlayClassName ? ` modal__overlay--${this.props.overlayClassName}` : ''
          }`}
        >
          <Headline modifier="article" importance={2} text={this.props.headline} />
          <Text text={this.props.message} modifier="small" />
          <ControlsGroup>
            <Button text={this.props.buttonText} event={this.props.onButtonClick} variant="primary" />
          </ControlsGroup>
        </ReactModal>
      </div>
    )
  }
}

NotificationModal.propTypes = {
  showModal: PropTypes.bool,
  onButtonClick: PropTypes.func.isRequired,
  modifier: PropTypes.string,
  overlayClassName: PropTypes.string,
  headline: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
}

export default NotificationModal
